import {
    DEFAULT_OFFSET,
    DEFAULT_PAGE,
    RECORDS_PER_PAGE,
} from "../domain/constants";
import {
    NotificationCollectionMeta,
    NotificationDTO,
} from "../domain/models/dto/NotificationDTO";
import { CollectionResponse } from "../types/ApiResults";
import { ApiServiceImpl, createAsyncThunkFactory } from "./ApiServiceImpl";

export class NotificationServiceImpl extends ApiServiceImpl {
    private constructor() {
        super();
    }

    static getShortNotificationsListThunk = createAsyncThunkFactory<
        CollectionResponse<NotificationDTO, NotificationCollectionMeta>,
        void
    >("NotificationServiceImpl.getShortNotificationsListThunk", async () => {
        return this.getCollection(
            "/api/v1/notification",
            {
                page: DEFAULT_PAGE,
                limit: RECORDS_PER_PAGE,
                offset: DEFAULT_OFFSET,
                read: false,
            },
            null,
            true
        );
    });

    static getNotificationsThunk = createAsyncThunkFactory<
        CollectionResponse<NotificationDTO>,
        { page: number; limit: number; offset: number; read: boolean }
    >("NotificationServiceImpl.getNotifications", async (args) => {
        return this.getCollection("/api/v1/notification", args);
    });

    static getUnreadNotificationsCountThunk = createAsyncThunkFactory<
        number,
        void
    >("NotificationServiceImpl.getUnreadNotificationsCount", async () => {
        return this.get("/api/v1/notification/unread-count", undefined, true);
    });

    static markAsReadNotificationThunk = createAsyncThunkFactory<
        NotificationDTO,
        NotificationDTO
    >("NotificationServiceImpl.markAsReadNotification", async (args) => {
        if (args.read) {
            return;
        }
        return this.patch(`/api/v1/notification/${args.id}/mark-as-read`, {});
    });
}
